// extracted by mini-css-extract-plugin
export default {"bar":"run-tabs_bar__z0a01"};